import React, { useState, useCallback } from 'react';
import * as MESSAGE from '../../../../common/constants/message';

export default function ChattingButton(props) {
  const [open, setOpen] = useState(false);

  const handleClick = useCallback(async () => {
    setOpen(!open);
    props.onClick(open);

  }, [open]);


  return (
    <div className={`live_btn_chat ${open ? 'current' : ''}`}>
      <button
        className='live_link_cont'
        title='플레이톡'
        //title={`${(props.chats !== null) ? '플레이톡' : MESSAGE.ALERT_LIVE_NOT_SUPPORT_CHATTING}`}
        aria-label={open ? '채팅 숨기기' : '채팅 표시'}
        onClick={handleClick.bind(this, 'livechat')}
      >
        <span className="live_btn_icon">
          <svg id="live_btn_chat" xmlns="http://www.w3.org/2000/svg" width="29" height="26" viewBox="0 0 29 26">
            <g id="live_btn_chat-2" data-name="live_btn_chat" transform="translate(-766.048 -498.726)">
              <path id="ic_chat" d="M278.924,338.938,275,340l1.052-3.964a7.933,7.933,0,0,1,4.783-11.6,11.013,11.013,0,0,0-.211,2.148,10.793,10.793,0,0,0,8.257,10.528,7.762,7.762,0,0,1-9.957,1.823Zm19.714-4.767a10.553,10.553,0,0,1-5.341,1.452,10.8,10.8,0,1,1,9.266-5.418L304,335.623Zm-14.183-9.36a8.9,8.9,0,0,0,8.842,8.932,8.75,8.75,0,0,0,4.41-1.2l.668-.39.745.2,2.25.608-.6-2.272-.2-.752.386-.675a8.868,8.868,0,1,0-16.5-4.454Zm10.349-.186a1.209,1.209,0,1,1,1.208,1.238A1.223,1.223,0,0,1,294.8,324.625Zm-4.834,0a1.209,1.209,0,1,1,1.208,1.238A1.223,1.223,0,0,1,289.97,324.625Z" transform="translate(491.047 184.725)" />
            </g>
          </svg>
          <i className="hide">라이브 톡</i>
        </span>
        <span className="iconSvg_beta"><i className="hide">베타</i></span>
      </button>
    </div>
  );
}
